import { defineStore } from "pinia";

export const useAccessibilityMenuStore = defineStore("accessibilityMenu", {
    state: () => ({
        keyboardTabLocation: "",
    }),
});
